import api from '../utils/api'
import { API_ROOT } from '../constants'

export const getDownloadAnalytics = (params, config) => api.get(`${API_ROOT}/v3/analytics/downloads`, params, config)

export const exportAllAnalytics = (params) =>
  api.get(`${API_ROOT}/v3/analytics/export-all`, params, undefined, {
    responseType: 'arraybuffer'
  })
